/**
 * @file 絞り込み
 */
'use strict';

import Common from "../../Utils/Common";

/**
 * @classname TableFilter
 * @classdesc 絞り込み
 */
export default class TableFilter {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('TableFilter.constructor');
		if(this._$e?.attr('id') !== 'saved-filter') {
			this._$e = $e;
			$e.on('change', () => this.onChange());
		}
	};


	/**
	 * changeのコールバック
	 *
	 * @memberof TableFilter
	 * @return {undefined}
	 */
	onChange() {
		console.log('TableFilter.onChange');
		const value = this._$e.val();
		const defaultValue = $('.table-sort option').eq(0).val();
		console.log(defaultValue);
		console.log(value);
		if(defaultValue ===  value) {
			this.tableFilter();
		}else{
			this.tableFilter(value);
		}
	};

	/**
	 * テーブルコントロール
	 *
	 * @memberof TableFilter
	 * @param {string} value - ソート
	 * @return {undefined}
	 */
	tableFilter(value = null) {
		console.log('TableFilter.TableFilter');
		let url = Common.getCurrentURL();
		console.log(url);
		if(value){
			location.href = `${url}?filter=${value}`;
		}else{
			location.href = `${url}`;
		}
	};
}
